import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { GlobalAssistantWidget } from './GlobalAssistantWidget';

const globalAssistantElement = AppRootElementBlueprint.make({
  params: {
    element: <GlobalAssistantWidget />,
  },
});

export const knowledgeGlobalAssistantModule = createFrontendModule({
  pluginId: 'app',
  extensions: [globalAssistantElement],
});
